<template>
    
    <div class="w-full min-h-screen" >

        <div></div>

        <div class=" w-112 h-full bg-gray-200 absolute right-0 top-0 px-10 py-20" >

            <form class="h-full flex flex-col" >

                <div class="flex-grow flex flex-col justify-center space-y-4" >

                    <c-input 
                    
                    type="email"
                    label="Email"
                    placeholder="jane.doe@gmail.com"

                    v-model="login.email.value"

                    @valid="login.email.valid = $event"

                    />
                
                    <c-input 
                    
                    type="password"
                    label="Password"
                    placeholder="password"

                    v-model="login.password.value"

                    @valid="login.password.valid = $event"

                    />

                    <p v-if="errors" class="h-auto py-2 ml-6 text-xs text-ch-red error relative tracking-widest" >{{errors}}</p>

                </div>

                <button 
                
                class="w-full btn-primary"

                :disabled="!valid" 
                
                @click.prevent="sendLogin"
 
                >
                
                    Login
                
                </button>

            </form>

        </div>

    </div>

</template>

<script>

    import { useStore } from 'vuex'
    import { useRouter } from 'vue-router'
    import { ref, reactive, computed } from 'vue'

    import cInput from '@/components/input'

    export default {
    
        name: 'Login',

        components: { cInput },

        setup(props, context) {

            const store = useStore()
            const router = useRouter()

            const login = reactive({

                email: {
                    value: '',
                    valid: false
                },

                password: {
                    value: '',
                    valid: false
                }

            })

            const valid = computed(() => login.email.valid && login.password.valid )

            const errors = ref('')

            const sendLogin = async () => {

                const data = new FormData()
                data.append( "Email", login.email.value )
                data.append( "Password", login.password.value )

                const auth = await store.dispatch('fetchy', {
                    url: 'api/account/login',
                    options: {
                        method: 'POST',
                        body: data
                    }
                })

                if ( auth.errors ) { errors.value = auth.errors.map( e => e.value ).join(' | ') }

                else {

                    const token = auth.token
                    store.commit( 'setAuth', token )
                    localStorage.setItem( 'token', token )

                    await store.dispatch('getClinics')

                    router.push('/')
                }

            }

            return {
                valid,
                login,
                errors,
                sendLogin
            }

        }

    }

</script>